export enum PermissionEnum {
  LeadView = 1,
  LeadCreate = 2,
  LeadUpdate = 3,
  LeadDelete = 4,
  CampaignView = 5,
  CampaignCreate = 6,
  CampaignUpdate = 7,
  CampaignDelete = 8,
  OpportunityView = 9,
  OpportunityUpdate = 11,
  OpportunityDelete = 12,
  UserView = 17,
  UserCreate = 18,
  UserUpdate = 19,
  UserDelete = 20,
  ReportDashboardView = 21,
  EncounterView = 22,
  EncounterUpdate = 24,
  CompanyView = 26,
  CompanyCreate = 27,
  CompanyUpdate = 28,
  CompanyDelete = 29,
  RoleView = 30,
  RoleCreate = 31,
  RoleUpdate = 32,
  RoleDelete = 33,
  LookupView = 42,
  LookupUser = 43,
  LookupCompany = 44,
  LookupCampaign = 45,
  LookupAgent = 46,
  LookupWhatsapp = 47,
  MetadataLeadView = 48,
  MetadataLeadCreate = 49,
  MetadataLeadUpdate = 50,
  MetadataLeadDelete = 51,
  MetadataCompanyView = 52,
  MetadataCompanyCreate = 53,
  MetadataCompanyUpdate = 54,
  MetadataCompanyDelete = 55,
  OpportunityViewAll = 56,
  OpportunityReassign = 57,
  EncounterViewAll = 58,
  EncounterReassign = 59,
}
